const Track = function () {};

Track.prototype.googleAds = () => {
  if (!!!window.gtag || typeof window.gtag !== "function") return;

  window.gtag("js", new Date());
  window.gtag("config", "AW-855676209");
};

Track.prototype.facebookAds = () => {
  if (!!!window.fbq || typeof window.fbq !== "function") return;
  window.fbq("init", "1672751816074624");
  window.fbq("track", "PageView");
};

Track.prototype.linkedinAds = () => {
  (function (l) {
    if (!l) {
      window.lintrk = function (a, b) {
        window.lintrk.q.push([a, b]);
      };
      window.lintrk.q = [];
    }
    var s = document.getElementsByTagName("script")[0];
    var b = document.createElement("script");
    b.type = "text/javascript";
    b.async = true;
    b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
    s.parentNode.insertBefore(b, s);
  })(window.lintrk);
};

Track.prototype.microsoftAds = path => {
  window.uetq = window.uetq || [];
  window.uetq.push("event", "page_view", { page_path: path });
};

Track.prototype.googleSignUp = type => {
  if (type === 1) {
    window.gtag("event", "conversion", {
      send_to: "AW-855676209/O_qiCOutwK4BELGqgpgD",
    });
  }
  if (type === 2) {
    window.gtag("event", "conversion", {
      send_to: "AW-855676209/_OQ1CN_T4skBELGqgpgD",
    });
  }
};

Track.prototype.facebookSignUp = type => {
  if (type === 1)
    window.fbq("track", "StartTrial", {
      value: "0.00",
      currency: "USD",
      predicted_ltv: "0.00",
    });
};

Track.prototype.microsoftSignup = type => {
  if (type === 1) {
    // Do something
  }
};

Track.prototype.signUp = function (isVBSSignUp, isFreeTrialOrHubOrSlidrSignUp) {
  const type = isFreeTrialOrHubOrSlidrSignUp ? 1 : isVBSSignUp ? 2 : 0;
  if (type === 0) return;
  this.googleSignUp(type);
  this.facebookSignUp(type);
  this.microsoftSignup(type);
};

Track.prototype.googlePurchase = value => {
  window.gtag("event", "conversion", {
    send_to: "AW-855676209/LETBCIKdta4BELGqgpgD",
    value,
    currency: "USD",
    transaction_id: "",
  });
};

Track.prototype.microsoftPurchase = revenue_value => {
  window.uetq = window.uetq || [];
  window.uetq.push("event", "Curriculum Purchase", {
    event_label: "Curriculum",
    event_value: 0,
    event_category: "Purchase",
    revenue_value: revenue_value,
    currency: "USD",
  });
};

Track.prototype.facebookPurchase = () => {};

Track.prototype.productPurchase = function (value) {
  this.googlePurchase(value);
  this.microsoftPurchase(value);
  this.facebookPurchase();
};

export const microsoftCode = `(function(w,d,t,r,u){var f,n,i;w[u]=w[u]||[],f=function(){var o={ti:"25078538"};o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")},n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function(){var s=this.readyState;s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)},i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)})(window,document,"script","//bat.bing.com/bat.js","uetq");`;

export const googleCode = `window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}`;

export const facebookCode = `!(function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod
      ? n.callMethod.apply(n, arguments)
      : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = "2.0";
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(
  window,
  document,
  "script",
  "https://connect.facebook.net/en_US/fbevents.js"
);`;

export const linkedinCode = `_linkedin_partner_id = "1573140";
window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
window._linkedin_data_partner_ids.push(_linkedin_partner_id);`;

// eslint-disable-next-line import/no-anonymous-default-export
export default new Track();
